/**
 * @generated SignedSource<<9a6d8cee0f76fc082b314c4e2114be7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArtistReferrals_partner$data = {
  readonly artistReferrals: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly recipientArtist: {
          readonly " $fragmentSpreads": FragmentRefs<"ReferralRecipientActive_recipient">;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"ReferralRecipientInvited_referral">;
      } | null;
    } | null>;
  };
  readonly id: string;
  readonly " $fragmentType": "ArtistReferrals_partner";
};
export type ArtistReferrals_partner$key = {
  readonly " $data"?: ArtistReferrals_partner$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArtistReferrals_partner">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ArtistReferrals_partner",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PartnerToArtistReferralNodeConnection",
      "kind": "LinkedField",
      "name": "artistReferrals",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PartnerToArtistReferralNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PartnerToArtistReferralNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ReferralRecipientInvited_referral"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ArtistNode",
                  "kind": "LinkedField",
                  "name": "recipientArtist",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ReferralRecipientActive_recipient"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PartnerNode",
  "abstractKey": null
};
})();

(node as any).hash = "312b21beeaa89ad6a218167c203e292a";

export default node;
